var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 53,
    viewBox: "0 0 56 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "121.2%",
    height: "114.1%",
    x: "-10.4%",
    y: "-5.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.284910402 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M18.793 1.575s.702 1.337-.208 3.992c-.909 2.655-1.996 4.16-.513 4.2 1.482.04 7.494.142 7.494.142a1.92 1.92 0 0 1 1.162.58c.306.318.477.741.478 1.182a1.795 1.795 0 0 1-1.318 1.703v.185a2.16 2.16 0 0 1 0 4.196h.014v.136a1.904 1.904 0 0 1-.989 3.518 1.436 1.436 0 0 1-.168 0c.314.288.494.694.498 1.12a1.696 1.696 0 0 1-1.347 1.584 1.4 1.4 0 0 1-.205.043h-.724c-2.217 0-7.666.023-7.666.023s-1.011.171-3.192-.758c-2.18-.929-2.895-.56-2.816-3.442.079-2.882.013-6.196.013-6.196s-.274-2.306 1.374-3.788c1.647-1.483 3.422-4.322 3.952-6.095.53-1.772.495-3.356 2.082-3.827 1.588-.471 2.079 1.502 2.079 1.502zM7.287 9.873c.454 0 .823.368.823.823v12.64a.83.83 0 0 1-.83.83H0L2.8 9.873h4.487z",
    filter: "url(#a)",
    transform: "translate(14 12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.0fdf52d3528c81e93a1930354b688035.svg";
export { ForwardRef as ReactComponent };